import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import SubtleBadge from 'components/common/SubtleBadge';
import {
  getBulkActionTypeBadgeColor,
  getBulkActionStatusBadgeColor,
} from 'constants/bulkAction';
import { TIME_OPTION } from 'constants/time';

export const BULK_ACTION_LIST_COLUMNS = [
  {
    accessorKey: 'type',
    header: 'Type',
    enableSorting: false,
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { type } = original;

      return (
        <SubtleBadge pill bg={getBulkActionTypeBadgeColor(type)}>
          {type}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'user',
    header: 'Uploaded by',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { user } = original;

      return <span>{user?.email || '-'}</span>;
    },
  },
  {
    accessorKey: 'row_count',
    header: 'Row Count',
    enableSorting: false,
    meta: {
      valueType: 'number',
    },
    cell: ({ row: { original } }) => {
      const { row_count } = original;

      return <span>{row_count.toLocaleString()}</span>;
    },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    enableSorting: false,
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { status } = original;

      return (
        <SubtleBadge pill bg={getBulkActionStatusBadgeColor(status)}>
          {status}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'created',
    header: 'Created',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { created } = original;

      return (
        <span>{new Date(created).toLocaleString('en-IN', TIME_OPTION)}</span>
      );
    },
  },
  {
    accessorKey: 'modified',
    header: 'Modified',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { modified } = original;

      return (
        <span>{new Date(modified).toLocaleString('en-IN', TIME_OPTION)}</span>
      );
    },
  },
  {
    accessorKey: 'failure_reason',
    header: 'Fail Reason',
    enableSorting: false,
    meta: {
      valueType: 'string',
      truncate: true,
      minWidth: '300px',
      maxWidth: '300px',
    },
    cell: ({ row: { original } }) => {
      const { failure_reason } = original;

      const popover = (
        <Popover id="popover">
          <Popover.Body>{failure_reason || '-'}</Popover.Body>
        </Popover>
      );

      return (
        <OverlayTrigger
          trigger="click"
          placement="auto"
          overlay={popover}
          rootClose
        >
          <span className="d-block text-truncate text-primary cursor-pointer">
            {failure_reason || '-'}
          </span>
        </OverlayTrigger>
      );
    },
  },
];
